import styled from 'styled-components';
import { Link } from 'react-router';

export const Page = styled.div`
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  padding: 32px 20px 64px;
`;

export const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.95rem;
  color: #2c5282;
  text-decoration: none;
  margin-bottom: 20px;
  font-weight: 600;
  &:hover {
    text-decoration: underline;
  }
`;

export const Title = styled.h1`
  font-family: 'Playfair Display', serif;
  font-size: 2rem;
  color: #19334d;
  margin: 0 0 8px 0;
  font-weight: 700;
`;

export const Subtitle = styled.p`
  color: #64748b;
  margin: 0 0 28px 0;
  font-size: 1rem;
  line-height: 1.5;
`;

export const Card = styled.section`
  background: #ffffff;
  border-radius: 12px;
  padding: 20px 22px;
  box-shadow: 0 2px 12px 0 rgba(25, 51, 77, 0.06);
  border: 1px solid #e7eaee;
  margin-bottom: 20px;
`;

export const CardTitle = styled.h2`
  font-size: 1.05rem;
  font-weight: 700;
  color: #223046;
  margin: 0 0 16px 0;
`;

export const Row = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
  &:first-of-type {
    padding-top: 0;
  }
`;

export const RowText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RowLabel = styled.span`
  font-weight: 600;
  color: #1e293b;
  font-size: 0.95rem;
`;

export const RowHint = styled.span`
  font-size: 0.85rem;
  color: #64748b;
`;

export const Toggle = styled.input.attrs({ type: 'checkbox' })`
  width: 44px;
  height: 24px;
  accent-color: #1a365d;
  cursor: pointer;
`;

export const CredentialRow = styled.div`
  padding-top: 4px;
`;

export const RevokeHint = styled.p`
  font-size: 0.85rem;
  color: #64748b;
  margin: 0 0 12px 0;
  line-height: 1.45;
`;

export const RevokeButton = styled.button`
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  border: 1.5px solid #b91c1c;
  background: #fff;
  color: #b91c1c;
  cursor: pointer;
  &:hover:not(:disabled) {
    background: #fef2f2;
  }
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    border-color: #cbd5e1;
    color: #94a3b8;
  }
`;

export const StatusMessage = styled.p`
  margin: 12px 0 0 0;
  font-size: 0.9rem;
  color: #15803d;
`;

export const ErrorMessage = styled.p`
  margin: 12px 0 0 0;
  font-size: 0.9rem;
  color: #b91c1c;
`;
